// extracted by mini-css-extract-plugin
export default {"page":"page_page__25zRi","main":"page_main__q6WVN"};